import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-end" }, null, -1)
const _hoisted_3 = { class: "pt-8" }
const _hoisted_4 = { class: "header flex items-center justify-end mb-4" }
const _hoisted_5 = { class: "flex items-center justify-between mb-4" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = { class: "text-lg font-semibold" }
const _hoisted_9 = { class: "text-sm italic color-blue-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxExport = _resolveComponent("DxExport")
  const _component_DxPaging = _resolveComponent("DxPaging")
  const _component_DxPager = _resolveComponent("DxPager")
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")
  const _component_DxColumn = _resolveComponent("DxColumn")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")
  const _component_DxGrouping = _resolveComponent("DxGrouping")
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (!_ctx.isLoading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          class: "add-permission",
          showHeader: false,
          visible: _ctx.showModal,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = $event)),
          modal: true,
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '50vw' }
        }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Tambah Permission",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitData())),
              icon: "pi pi-plus",
              class: "font-semibold p-button-sm btn-primary"
            })
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("i", {
                  class: "pi pi-times cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog()))
                })
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", null, _toDisplayString(`Tambahkan Permission ${_ctx.groupName}`), 1)
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_DxDataGrid, {
                    ref: "refTableDeliveryItem",
                    id: "delivery-item-table-id",
                    class: "delivery-item-table",
                    "column-auto-width": true,
                    "allow-column-reordering": false,
                    "show-column-lines": false,
                    "show-row-lines": true,
                    "show-borders": true,
                    "row-alternation-enabled": true,
                    "allow-column-resizing": false,
                    "word-wrap-enabled": true,
                    "data-source": _ctx.permissionList,
                    "key-expr": "Id",
                    "no-data-text": _ctx.noDataText,
                    onExporting: _ctx.exportGrids
                  }, {
                    descriptionTemplate: _withCtx(({ data }) => [
                      _createVNode("div", null, [
                        _createVNode("div", _hoisted_8, _toDisplayString(data.data.Description), 1),
                        _createVNode("div", _hoisted_9, _toDisplayString(`( ${data.data.Name} )`), 1)
                      ])
                    ]),
                    actionTemplate: _withCtx(({ data }) => [
                      _createVNode("div", null, [
                        _createVNode(_component_Checkbox, {
                          modelValue: _ctx.selectedList,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedList = $event)),
                          class: "checkbox-primary",
                          inputId: data.data,
                          name: "category",
                          value: data.data,
                          disabled: _ctx.checkPermissionExist(data.data.Id)
                        }, null, 8, ["modelValue", "inputId", "value", "disabled"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_DxExport, {
                        enabled: false,
                        "allow-export-selected-data": false
                      }),
                      _createVNode(_component_DxPaging, {
                        "page-size": 20,
                        enabled: true
                      }),
                      _createVNode(_component_DxPager, {
                        visible: true,
                        "allowed-page-sizes": _ctx.pageSizes,
                        "display-mode": _ctx.displayMode,
                        "show-page-size-selector": _ctx.showPageSizeSelector,
                        "show-info": _ctx.showInfo,
                        "show-navigation-buttons": _ctx.showNavButtons
                      }, null, 8, ["allowed-page-sizes", "display-mode", "show-page-size-selector", "show-info", "show-navigation-buttons"]),
                      _createVNode(_component_DxFilterRow, { visible: _ctx.showFilterRow }, null, 8, ["visible"]),
                      _createVNode(_component_DxHeaderFilter, { visible: _ctx.showHeaderFilter }, null, 8, ["visible"]),
                      _createVNode(_component_DxColumnChooser, {
                        enabled: false,
                        mode: "select",
                        title: "Pilih Kolom",
                        "allow-search": true
                      }),
                      _createVNode(_component_DxColumn, {
                        "data-field": "groupName",
                        caption: "Group",
                        visible: true,
                        width: 130
                      }),
                      _createVNode(_component_DxColumn, {
                        caption: "Permission Yang Diijinkan",
                        "data-field": "Description",
                        visible: true,
                        "min-width": 130,
                        "cell-template": "descriptionTemplate",
                        alignment: "left",
                        "allow-grouping": false
                      }),
                      _createVNode(_component_DxColumn, {
                        caption: "",
                        visible: true,
                        width: 100,
                        "cell-template": "actionTemplate",
                        alignment: "left"
                      }),
                      _createVNode(_component_DxGroupPanel, {
                        visible: true,
                        "empty-panel-text": "Drag kolom ke sini untuk mengelompokkan menurut kolom tersebut"
                      }),
                      _createVNode(_component_DxGrouping, {
                        "auto-expand-all": false,
                        "context-menu-enabled": true,
                        "expand-mode": "rowClick"
                      }),
                      _createVNode(_component_DxSearchPanel, { visible: true })
                    ]),
                    _: 1
                  }, 8, ["data-source", "no-data-text", "onExporting"])
                ])
              ]),
              _createVNode("pre", null, _toDisplayString(_ctx.userPermissionList), 1)
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}